import type { StadiumCommercialModules } from '../../core/models/types';

// Approximation of StadiumAttendanceCalculator (stadium-demand-v2-home-streak).
// Standings are neutral and home streak is zero; commercial rates use the backend's default calibration.
const OCCUPANCY = [1, .92, .85, .78, .72, .66, .60, .55, .50, .46, .42, .38, .35, .32, .29];
const COEFFICIENTS = [0, 1, 1.15, 1.35, 1.60, 2];
export function normalizeTicketPrice(value: unknown): number {
  const price = Number(value);
  return Math.round(Math.max(10, Math.min(150, Number.isFinite(price) ? price : 115)) * 100) / 100;
}

export function estimateStadiumAttendance(capacity: number, price: unknown, modules: StadiumCommercialModules) {
  capacity = Number.isFinite(capacity) ? Math.max(0, Math.floor(capacity)) : 0;
  const ticketPrice = normalizeTicketPrice(price);
  const index = Math.floor(ticketPrice / 10) - 1;
  const fraction = (ticketPrice % 10) / 10;
  const base = OCCUPANCY[index] + ((OCCUPANCY[index + 1] ?? OCCUPANCY[index]) - OCCUPANCY[index]) * fraction;
  const level = (value: number | undefined) => Number.isFinite(value) ? Math.max(0, Math.min(5, Math.floor(value!))) : 0;
  const parking = level(modules.parkingLevel);
  const bathrooms = level(modules.bathroomLevel);
  const cafeteria = level(modules.cafeteriaLevel);
  const shops = level(modules.merchandisingLevel);
  const stadiumFactor = 1 + (parking * .08 + bathrooms * .10 + cafeteria * .07 + shops * .05) / 5;
  const attendance = Math.min(capacity, Math.round(capacity * base * stadiumFactor));
  return {
    capacity,
    attendance,
    percentage: capacity > 0 ? attendance / capacity * 100 : 0,
    ticketRevenueM: attendance * ticketPrice / 1_000_000,
    commercialRevenueM: attendance * (1.5 * COEFFICIENTS[parking] + 3 * COEFFICIENTS[cafeteria] + 2 * COEFFICIENTS[shops]) / 1_000_000,
  };
}
